import { getOrSetUniqueIdentifier } from '@mono-farmart-web/utilities/utils';
import { createContext, useContext, ReactNode, useMemo } from 'react';

interface ISessionContext {
	sessionId: string;
}
const SessionContext = createContext<ISessionContext | null>(null);

export const useSessionContext = (): ISessionContext => {
	const context = useContext(SessionContext);
	if (!context) {
		throw new Error('useSessionContext must be used within an ApiProvider');
	}
	return context;
};

interface SessionProviderProps {
	children: ReactNode;
}

export const SessionProvider = ({ children }: SessionProviderProps) => {
	const sessionId = useMemo(
		() => getOrSetUniqueIdentifier('fmt-ai-session-id', 'session'),
		[],
	);
	return (
		<SessionContext.Provider value={{ sessionId }}>
			{children}
		</SessionContext.Provider>
	);
};
